import * as React from "react";
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils";

const badgeVariants = cva(
	"inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors",
	{
		variants: {
			variant: {
				default:
					"border-transparent bg-[var(--primary-color)] text-[var(--button-text-color)]",
				secondary:
					"border-transparent bg-[var(--secondary-color)] text-[var(--text-color)]",
				outline:
					"border-[var(--border-color)] text-[var(--text-color)]",
				success:
					"border-transparent bg-[color:var(--success-color)] text-white",
				destructive:
					"border-transparent bg-[color:var(--error-color)] text-white",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	}
);

function Badge({ className, variant, ...props }) {
	return (
		<div className={cn(badgeVariants({ variant }), className)} {...props} />
	);
}

export { Badge, badgeVariants };
